/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Notifications_Tags_Dialog_DescriptionInputs */

const he_notifications_tags_dialog_description = /** @type {(inputs: Notifications_Tags_Dialog_DescriptionInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`קבלו התראות על שינויי מחיר במוצרים עם התגיות שבחרתם`)
};

const en_notifications_tags_dialog_description = /** @type {(inputs: Notifications_Tags_Dialog_DescriptionInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Get notified about price changes for products with the selected tags`)
};

/**
* | output |
* | --- |
* | "Get notified about price changes for products with the selected tags" |
*
* @param {Notifications_Tags_Dialog_DescriptionInputs} inputs
* @param {{ locale?: "he" | "en" }} options
* @returns {LocalizedString}
*/
export const notifications_tags_dialog_description = /** @type {((inputs?: Notifications_Tags_Dialog_DescriptionInputs, options?: { locale?: "he" | "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Notifications_Tags_Dialog_DescriptionInputs, { locale?: "he" | "en" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "he") return he_notifications_tags_dialog_description(inputs)
	return en_notifications_tags_dialog_description(inputs)
});